var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},[_vm._l((_vm.availableSlots),function(slot){return [_c('v-col',{key:slot.label,staticClass:"grow",attrs:{"cols":"auto"}},[_c('AvailableSlot',_vm._g({attrs:{"available-slot":slot,"selected-slots":_vm.selectedSlots}},_vm.$listeners))],1)]})],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }